
export class CollectionStaticData {

  public static COLLECTION_METHOD = 'fedcc40e-0f2e-451c-90b5-3697c4aa808f';

  public static COLLECTION_TYPE = 'f34cca9a-75a0-431e-88cc-d605b9f38414';
  public static COLLECTION_INSPECTION = '5265318c-5322-429b-967f-b67d0141f55b';

  public static COLLECTION_TYPE_INSPECTION_ID = '27bc58e55d9f4326846796cfce711039';
  public static COLLECTION_TYPE_REPAIR_ID = '6850e3762be149d7a0582abd9dccc582';
  public static COLLECTION_TYPE_STRUCTURE_ID = 'b0675e9cbaf244cda6199cb460a2bacd';
  public static COLLECTION_TYPE_TEMPLATE_ID = 'bcd039be7fe547fb98279910956daf06';
  public static COLLECTION_TYPE_FEA_ID = '4c41a67f39114591ab80eef2fc88d5aa';
  public static COLLECTION_TYPE_PROTECTION_ID = '4e5f78cd5e5f40b4a4b56e2e76f8a0b6';

  public static COLLECTION_STATUS_INIT_ID = '45fc0dce-e0b1-4688-8a55-967e712687fd';
}
